import { useRef, useState } from "react";
import { UploadCloud } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { apiError } from "@/admin/ui";

const MAX = 600 * 1024 * 1024;

async function uploadFile(file, onProgress) {
  const type = file.type || (file.name.toLowerCase().endsWith(".pdf") ? "application/pdf" : "application/octet-stream");
  const { data } = await api.post("/admin/uploads", { name: file.name, size: file.size, content_type: type });
  const size = data.chunk_size;
  for (let i = 0, off = 0; off < file.size; i++, off += size) {
    await api.post(`/admin/uploads/${data.upload_id}/chunk?index=${i}`, file.slice(off, off + size),
      { headers: { "Content-Type": "application/octet-stream" } });
    onProgress(Math.min(95, Math.round(((off + size) / file.size) * 95)));
  }
  const res = await api.post(`/admin/uploads/${data.upload_id}/complete`);
  onProgress(100);
  return res.data;
}

export default function Uploader({ onUploaded, accept = "video/*,audio/*,application/pdf,image/*", label = "Arrastra un archivo o pulsa para elegirlo", hint = "Vídeo, audio, PDF o imagen · máximo 600 MB", testid = "admin-uploader" }) {
  const input = useRef(null);
  const [pct, setPct] = useState(null);
  const [over, setOver] = useState(false);
  const start = async (file) => {
    if (!file) return;
    if (file.size > MAX) { toast.error("El archivo supera los 600 MB."); return; }
    setPct(0);
    try {
      const f = await uploadFile(file, setPct);
      toast.success(`Subido: ${f.name}`);
      onUploaded?.(f);
    } catch (e) { toast.error(apiError(e)); } finally { setPct(null); if (input.current) input.current.value = ""; }
  };
  return (
    <div className={`adm-drop ${over ? "over" : ""}`} data-testid={testid}
      onClick={() => pct === null && input.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); if (pct === null) start(e.dataTransfer.files[0]); }}>
      <input ref={input} type="file" accept={accept} hidden onChange={(e) => start(e.target.files[0])} data-testid={`${testid}-input`} />
      {pct === null ? (
        <><UploadCloud size={22} style={{ margin: "0 auto .4rem", color: "#2E9E5B" }} /><b style={{ color: "#10151C" }}>{label}</b>
          <div className="adm-sub" style={{ marginTop: 4 }}>{hint}</div></>
      ) : (
        <div data-testid={`${testid}-progress`}>
          <div className="adm-bar" style={{ maxWidth: 320, margin: "0 auto .5rem" }}><b style={{ width: `${pct}%` }} /></div>
          <span className="adm-sub">Subiendo... {pct}%</span>
        </div>
      )}
    </div>
  );
}
